import { render, staticRenderFns } from "./InventarioItens.vue?vue&type=template&id=4f82390b&"
import script from "./InventarioItens.vue?vue&type=script&lang=js&"
export * from "./InventarioItens.vue?vue&type=script&lang=js&"
import style0 from "./style.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports